export default __webpack_public_path__ + "static/media/atoai.7b1ac490.svg";